interface CategoryEditableInput {
  hasExistingCategoryLinks: boolean;
  categoryNeedsReview: boolean;
}

interface LanguageEditableInput {
  hasExistingLanguageLinks: boolean;
  languageNeedsReview: boolean;
}

interface VerifyPayloadFieldsInput {
  categoryEditable: boolean;
  languageEditable: boolean;
  categoryIds: string[];
  languageIds: string[];
}

interface VerifyPayloadFields {
  categoryIds?: string[];
  languageIds?: string[];
}

export const isCategoryFieldEditable = ({
  hasExistingCategoryLinks,
  categoryNeedsReview,
}: CategoryEditableInput): boolean => !hasExistingCategoryLinks || categoryNeedsReview;

export const isLanguageFieldEditable = ({
  hasExistingLanguageLinks,
  languageNeedsReview,
}: LanguageEditableInput): boolean => !hasExistingLanguageLinks || languageNeedsReview;

export const buildVerifyPayloadFields = ({
  categoryEditable,
  languageEditable,
  categoryIds,
  languageIds,
}: VerifyPayloadFieldsInput): VerifyPayloadFields => ({
  ...(categoryEditable ? { categoryIds } : {}),
  ...(languageEditable ? { languageIds } : {}),
});
